import cx from 'classnames'
import { Check } from 'lucide-react'

import { Icon } from 'ui'

export const intervalUnit = interval => {
  if (interval === 'monthly') return 'month'
  if (interval === 'yearly') return 'year'
  return interval || 'term'
}

export const intervalDescription = (amount, interval) => (
  `${amount} today, then ${amount} each ${intervalUnit(interval)}. Cancel any time from the Web Management Console.`
)

const upgradeFeatures = [
  'MSI, .deb and .rpm installers',
  'Server token to register your instance',
  'Fleet config across every device on the key',
]

export const UpgradeFeatureList = ({ className }) => (
  <ul className={cx('tw:grid tw:text-sm tw:text-foreground-muted', className)}>
    {upgradeFeatures.map(feature => (
      <li className="tw:flex tw:items-start tw:gap-2" key={feature}>
        <Icon as={Check} className="tw:mt-0.5 tw:shrink-0 tw:text-status-success-foreground" size={16} />
        <span>{feature}</span>
      </li>
    ))}
  </ul>
)
